export default __webpack_public_path__ + "static/media/season.48e72be2.svg";